import styled from "styled-components"
import backgroundSrc from './assets/backgroundNoBlur.png'
import { animated } from '@react-spring/web'

export default styled(animated.div)`
    display: flex;
    justify-content: center;
    align-items: flex-end;
    z-index: 5;
    position: relative;

    height: calc(100vh - 5rem);
    width: 100%;
    max-width: 900px;
    min-width: 900px;
    max-height: calc(100% - 16px);
    transform-origin: 50% 120%;

    &::after {
        position: absolute;
        content: ' ';
        background-image: url(${backgroundSrc});
        bottom: 0;
        right: 0;
        left: 0;
        height: 1070px;
        background-size: 100% auto;
        background-position: bottom left;
        background-repeat: no-repeat;
        z-index: 15;

    }
    @media screen and (max-width: 1260px) {
        transform: scale(0.8);
    }

    @media screen and (max-height: 1160px) {
        transform: scale(0.8);
    }

    @media screen and (max-height: 960px) {
        transform: scale(0.7);
    }



    @media screen and (max-width: 400px) {
        transform: scale(0.55);
        transform-origin: 55% 110%;

    }

    @media screen and (max-height: 800px) {
        transform: scale(0.5);
    }

    @media screen and (max-height: 720px) {
        transform: scale(0.45);

    }

    @media screen and (max-height: 550px) {
        transform: scale(0.35);

    }

`;
